import styled from '@emotion/styled'
import { typography } from 'main/ui'

export const Container = styled.div`
  font-family: ${typography.fontFamily.ui};

  > input[type='text'] {
    visibility: hidden;
  }

  > .flatpickr-calendar {
    box-shadow: none;
  }

  .event {
    position: absolute;
    width: 3px;
    height: 3px;
    border-radius: 150px;
    bottom: 3px;
    left: calc(50% - 1.5px);
    content: ' ';
    display: block;
    background: #3d8eb9;
  }

  .flatpickr-day.selected,
  .flatpickr-day.startRange,
  .flatpickr-day.endRange,
  .flatpickr-day.selected.inRange,
  .flatpickr-day.startRange.inRange,
  .flatpickr-day.endRange.inRange,
  .flatpickr-day.selected:focus,
  .flatpickr-day.startRange:focus,
  .flatpickr-day.endRange:focus,
  .flatpickr-day.selected:hover,
  .flatpickr-day.startRange:hover,
  .flatpickr-day.endRange:hover,
  .flatpickr-day.selected.prevMonthDay,
  .flatpickr-day.startRange.prevMonthDay,
  .flatpickr-day.endRange.prevMonthDay,
  .flatpickr-day.selected.nextMonthDay,
  .flatpickr-day.startRange.nextMonthDay,
  .flatpickr-day.endRange.nextMonthDay {
    background: transparent;
    box-shadow: none;
    color: inherit;
    border-color: transparent;
  }

  .flatpickr-day.today {
    border-color: transparent;
  }
`
